<template>
  <div>
    <!-- LinkedIn Link Preview -->
    <div :class="`flex-fill ${spacing}`">

      <div>
        <b-img v-if="!loading" :src="imageURL || defaults.imageURL" alt="Image" fluid />
        <div v-if="loading" class="d-flex justify-content-center align-items-center" style="height: 200px;">
          <b-spinner type="grow" variant="primary" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    shareText: {
      type: String,
      default: '-',
    },
    spacing: {
      type: String,
      default: 'p-3',
    },
    imageURL: {
      type: String,
      default: 'https://placehold.co/600x600',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showShareText: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    defaults() {
      return {
        imageURL: 'https://placehold.co/600x600'
      };
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/content-share/content-share-editor/ContentShareImage.vue